import { useMutation } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, UpdateUserRequest, User } from "@/types";

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: async ({
      updateUserRequest,
      userId,
    }: {
      updateUserRequest: UpdateUserRequest;
      userId: number;
    }) => {
      const res = await httpClient.post<
        User,
        HttpResponse<User>,
        UpdateUserRequest
      >(`users/${userId.toString()}`, updateUserRequest);

      return res.data;
    },
  });
};
